export default __webpack_public_path__ + "static/media/teams.905180a9.svg";